import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

const isPasswordResetRequired = (data) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.LOGIN.IS_PASSWORD_RESET_REQUIRED,
    data
  );
};

export default isPasswordResetRequired;
